var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBiking = function SvgBiking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 15,
    cy: 3.75,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 4.5,
    cy: 18.75,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 19.5,
    cy: 18.75,
    r: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M12 20.25a1.5 1.5 0 0 1-1.5-1.5 5.99 5.99 0 0 0-3.236-5.328 1.5 1.5 0 0 1-.34-2.417l4.043-3.842a1.5 1.5 0 0 1 2.375.416c.007.013 1.145 2.171 3.158 2.171a1.5 1.5 0 0 1 0 3 6.32 6.32 0 0 1-4.709-2.231L10.339 11.9a8.97 8.97 0 0 1 3.161 6.85 1.5 1.5 0 0 1-1.5 1.5"
  }))));
};
export default SvgBiking;